import React from 'react';

import WidgetAjax from '../widget/WidgetAjax';
import WidgetModal from '../widget/WidgetModal';
import Config from '../config/Config';

import Features from './Features';
import EntityPanorama from './EntityPanorama';
import EntityDevelopment from './EntityDevelopment';
import EntityKnowledge from './EntityKnowledge';

// import Record from "./entityPanorama/Record"
import Transaction from "./entityPanorama/Transaction"
import Similar from "./entityPanorama/similar"
import Valuation from "./entityPanorama/valuation"
import Registration from './entityPanorama/Registration';
import Risk from './entityPanorama/Risk';
import NewEnt from './entityPanorama/NewEnt';
import WidgetMessage from '../widget/WidgetMessage';


import telePhone from "../img/riskCompass/telephone.svg"
import BackToTop from "../img/BusinessChance/backToTop.svg";
import Cache from '../frame/Cache';
import moment from 'moment'

import '../css/base.css'
import '../css/scrm.css'
import '../css/scrm.table.css'

class EntityDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            basePath: Config.getBasePath(),
            item: props.data,
            entity: {},
            features: [],
            risks: [],
            clues: [],
            tags: [],
            catalogs: [],
            tels: [],
            entityType: 2,
            amap: {
                mapZoom: 13, //地图缩放等级 （zoom）
                mapKey: 'f8061d856445cfb7db9937cd5c98aa05',//Key就不贴出来了奥
                status: {
                    zoomEnable: true,
                    dragEnable: true,
                },
                mapCenter: [116.292329, 39.946996], //地图中心点
                mapMakes: [], //marker标记点
            },
            messageOptions: {
                title: '信息',
            },
            loading: true,
            scrollTop: 0,
            headersHeight: 0,
            tabHeight: 0,
            isBackTop: false,
            curIndex: 0,
            VirtualPhoneNum: undefined,
            reciprocal: false,
            PHONEDate: undefined,
            SECRET: 1,
            cell: undefined,
            isNewFirm: false, // 是否是新企
        }

        this.labelChange = this.labelChange.bind(this);

        this.loadEntity = this.loadEntity.bind(this);
        this.onLoadEntity = this.onLoadEntity.bind(this);

        this.addMonitor = this.addMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);

        this.removeMonitor = this.removeMonitor.bind(this);
        this.removeMonitorConfirm = this.removeMonitorConfirm.bind(this);
        this.onRemoveMonitor = this.onRemoveMonitor.bind(this);

        this.addCRM = this.addCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);
        this.removeCRM = this.removeCRM.bind(this);
        // this.addFavor = this.addFavor.bind(this);
        // this.removeFavor = this.removeFavor.bind(this);
        this.Scroll = this.Scroll.bind(this);
        this.getHead = this.getHead.bind(this);
        this.setScrollTop = this.setScrollTop.bind(this);
        this.setTop = this.setTop.bind(this);

        this.VirtualPhoneClick = this.VirtualPhoneClick.bind(this);
        this.onVirtualPhoneClick = this.onVirtualPhoneClick.bind(this);
        this.virtualNumber = this.virtualNumber.bind(this);
        this.onVirtualNumber = this.onVirtualNumber.bind(this);
    }

    componentDidMount() {
        this.state["item"] = this.props.data;
        this.loadEntity();
        this.virtualNumber();

        Config.getHermesAccess(this.onLoadToken);



        let data = window.sessionStorage.getItem("_user_info_");

        let res = JSON.parse(data);

        this.setState({ cell: res.cell })
    }

    onLoadToken = (result) => {
        if (result.status === 0) {
            this.loadAnnals(result.result.token);
        }
        else if (result.status === 10) {
            Cache.logout(this.props.parentProps);
        }
    }

    loadAnnals = (access) => {
        const params = {
            ENTNAME: this.state.item.ENTNAME,
            access,
            service: "getAnnReportList",
            user: Config.getHermesPanoramaUID()
        }

        const onLoadAnnals = (res) => {
            if (res.status === 0) {
                if (res.total === 0) {
                    this.setState({ isNewFirm: true })
                } else {
                    this.setState({ isNewFirm: false })
                }
            }
        }
        WidgetAjax.ajax({ url: Config.getHermesPanoramaURL(), params, callback: onLoadAnnals })
    }

    componentWillReceiveProps(nextProps) {
        this.state["item"] = nextProps.data;

        if (nextProps.data !== undefined) {
            this.loadEntity();
        }

    }



    loadEntity() {
        const { item, basePath } = this.state;

        if (item !== undefined && item !== null) {
            let params = {
                ENTID: item.ENTID || item.entid
            };

            WidgetAjax.ajax({ url: basePath + '/entity/info', params: params, callback: this.onLoadEntity });
            this.setState({ loading: true });

        }
    }

    onLoadEntity(result, params) {
        if (result.status === 0) {
            let riskClass, riskLevel, entity = result.result;
            this.setState({ enterpriseWarning: result.results, loading: false });

            if (!entity.MONITOR) {
                this.setState({
                    entityType: 2
                })
            }
            // else if(this.props.flag !== undefined){
            //     this.setState({
            //         entityType: 2
            //     })
            // }

            let { amap, disposalParams } = this.state;

            // let riskSCORE = entity.RISKSCORE !== undefined ? entity.RISKSCORE : 0;
            let realms = entity.REALMS !== undefined ? entity.REALMS : [];

            let risks = [], features = [], catalogs = [], clues = [], tags = [], tels = [];

            if (entity.FEATURES !== undefined) {
                for (let key in entity.FEATURES) {
                    let item = {
                        code: key,
                        name: entity.FEATURES[key]
                    }

                    features.push(item);
                }
            }

            if (entity.CATALOGS !== undefined) {
                for (let key in entity.CATALOGS) {
                    let item = {
                        code: key,
                        name: entity.CATALOGS[key]
                    }

                    catalogs.push(item);
                }
            }

            if (entity.RISKS !== undefined) {
                for (let key in entity.RISKS) {
                    let item = {
                        code: key,
                        name: entity.RISKS[key]
                    }

                    risks.push(item);
                }
            }

            if (entity.CLUES !== undefined) {
                for (let key in entity.CLUES) {
                    let item = {
                        code: key,
                        name: entity.CLUES[key]
                    }

                    clues.push(item);
                }
            }

            if (entity.TAGS !== undefined) {
                for (let key in entity.TAGS) {
                    let item = {
                        code: key,
                        name: entity.TAGS[key]
                    }

                    tags.push(item);
                }
            }


            if (entity.LOCATION !== undefined && entity.LOCATION !== null) {
                let point = [entity.LOCATION.lon, entity.LOCATION.lat];
                amap["mapCenter"] = point;

                amap["mapMakes"].push(point);
            }

            let tel = "", isFirst = true;
            if (entity.TEL !== undefined && entity.TEL !== null) {
                for (let item of entity.TEL) {
                    if (isFirst) {
                        tel = item
                        isFirst = false;
                    }
                    else {
                        tel += "；" + item;
                    }
                }

                tels.push(...entity.TEL);
            }

            let mail = ""; isFirst = true;
            if (entity.MAIL !== undefined && entity.MAIL !== null) {
                for (let item of entity.MAIL) {
                    if (isFirst) {
                        mail = item
                        isFirst = false;
                    }
                    else {
                        mail += "；" + item;
                    }
                }
            }

            this.setState({
                entity: entity, mail: mail, tel: tel, tels: tels, realms: realms, risks: risks, catalogs: catalogs, tags: tags,
                features: features, clues: clues, riskLevel: riskLevel, riskClass: riskClass
            });
            //LOCATION
        }
        else if (result.status === 10) {
            Cache.logout(this.props);
        }

    }


    labelChange(type, value, obj) {
        for (let i = 0; i < obj.currentTarget.parentNode.childNodes.length; i++) {
            obj.currentTarget.parentNode.childNodes[i].className = "label_common click ";
        }

        obj.currentTarget.className = 'label_common label_active click';

        this.setState({ scrollTop: 0, curIndex: 0 }, () => {
            this.setScrollTop(this.state.scrollTop)
        })

        switch (type) {
            case "entity":
                {
                    this.setState({ entityType: value, screenTop: 0 });
                    break;
                }
            default:
                break;
        }

    }

    /** 消息提示框句柄 */
    setMessageRef = (ref) => {
        this.messageRef = ref;
    }

    /**
     * 添加监控
     */
    addMonitor() {
        let { messageOptions, entity } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions["message"] = `确定要把 '` + entity.ENTNAME + `' 添加到监控企业中吗?`;

        messageOptions['confirmFunction'] = this.addMonitorConfirm;

        messageOptions["title"] = "添加监控";

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();

    }

    /**
     * 添加监控确认方法
     */
    addMonitorConfirm() {
        const { basePath, entity } = this.state;

        let params = {
            ENTID: entity.ENTID
        };

        WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entity } });


    }

    /**
     * 添加监控回调函数
     * @param {*} result 
     * @param {*} params 
     * @param {*} backParam 
     */
    onAddMonitor(result, params, backParam) {
        if (result.status === 0) {
            let { messageOptions, entity } = this.state;

            messageOptions["isMessage"] = true;

            messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加到监控企业中！`;

            messageOptions["title"] = "添加监控企业";

            this.state['messageOptions'] = messageOptions;

            entity["MONITOR"] = true;
            this.messageRef.open();

            this.setState({ entity: entity });

            this.props.search()
        }
        else if (result.status === 10) {
            Cache.logout(this.props);
        }
    }




    /**
     * 取消监控企业
     */
    removeMonitor() {
        let { messageOptions, entity } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + entity.ENTNAME + `' 从监控企业中移除吗?`;

        messageOptions["title"] = "取消监控";

        this.state['messageOptions'] = messageOptions;
        this.messageRef.open();
    }

    removeMonitorConfirm() {

        const { basePath, entity } = this.state;

        let params = {
            ENTID: entity.ENTID
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_entity', params: params, callback: this.onRemoveMonitor, backParam: { data: entity } });
    }

    onRemoveMonitor(result, params, backParam) {
        if (result.status === 0) {
            let { messageOptions, entity } = this.state;

            messageOptions["isMessage"] = true;

            messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添从监控企业中移除！`;

            messageOptions["title"] = "取消监控";

            this.state['messageOptions'] = messageOptions;

            entity["MONITOR"] = false;

            this.messageRef.open();

            this.setState({ entity: entity });

            this.props.search()
        }
        else if (result.status === 10) {
            Cache.logout(this.props);
        }
    }


    addCRM() {

        let { messageOptions, entity } = this.state;
        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要把 '` + entity.ENTNAME + `' 添加至CRM中吗?`;
        messageOptions['confirmFunction'] = this.addCRMConfirm;
        messageOptions["title"] = "添加CRM";
        // messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }


    addCRMConfirm() {
        const { basePath, entity } = this.state;

        let params = {
            ENTID: entity.ENTID
        };
        WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddCRM, backParam: { data: entity } });
    }

    /**
     * 添加监控回调函数
     * @param {*} result 
     * @param {*} params 
     * @param {*} backParam 
     */
    onAddCRM(result, params, backParam) {
        if (result.status === 0) {
            if (backParam.checkData) {
                let { messageOptions, entity } = this.state, isFirst = true, addCRMName = '';

                messageOptions["isMessage"] = true;

                for (let item in backParam.checkData) {
                    if (isFirst) {
                        addCRMName = backParam.checkData[item].ENTNAME;
                        isFirst = false
                    }
                    else {
                        addCRMName += ", " + backParam.checkData[item].ENTNAME;
                    }
                }

                let defeatedAdd = backParam.checkData.length - result.result

                messageOptions["message"] = `已将 ${addCRMName} 添加至CRM!  有 ${result.result} 条添加成功， 有 ${defeatedAdd} 条已存在CRM中或添加失败！`;

                messageOptions["title"] = "添加成功";

                this.state['messageOptions'] = messageOptions;
            }
            else {
                let { messageOptions } = this.state;

                messageOptions["isMessage"] = true;
                messageOptions["message"] = `已将 ${backParam.data.ENTNAME} 添加至CRM!`;
                messageOptions["title"] = "添加成功";

                this.state['messageOptions'] = messageOptions;
            }

            this.messageRef.open();
        }
        else if (result === 10) {
            Cache.logout(this.props);
        }
        else if (result.status === -1) {
            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }

        this.state["isBatch"] = false
    }

    removeCRM() {

    }

    getHead(el) {
        this.head = el;
    }

    Scroll() {
        let entityDetailHeaders = document.getElementById("entityDetailHeaders");
        let entityDetailPage = document.getElementById("entityDetailPage");
        // let bottom = entityDetailPage.scrollTop + entityDetailPage.clientHeight >= entityDetailPage.scrollHeight


        let headersHeight = entityDetailHeaders.clientHeight;

        this.setState({
            scrollTop: entityDetailPage.scrollTop,
            headersHeight
        })
        if (entityDetailPage.scrollTop >= headersHeight) {
            this.setState({
                isBackTop: true
            })
        } else {
            this.setState({
                isBackTop: false
            })
        }
    }


    setScrollTop(top, bottom) {
        this.head.scrollTop = top
    }


    setTop() {
        this.setState({ scrollTop: 0 }, () => {
            this.setScrollTop(this.state.scrollTop)
        })
    }

    /**
    * 隐藏联系方式
    */
    virtualNumber() {
        const { item, basePath } = this.state;

        let params = {
            ENTNAME: item.ENTNAME || item.entNAME
        };

        WidgetAjax.ajax({ url: basePath + '/phone/search', params: params, callback: this.onVirtualNumber });
        this.setState({ loading: true });
    }
    onVirtualNumber(result) {
        if (result.status === 0) {
            let phone = result.results[0];

            let VirtualPhoneNum = phone.PHONE;

            let SECRET = phone.SECRET;

            let PHONETYPE = phone.PHONETYPE;

            let SOURCE = phone.SOURCE === "1" ? "工商登记" : "其他";

            let RATE = phone.RATE

            if (phone.PHONE !== undefined && phone.PHONE !== null && phone.PHONE !== "") {
                // this.setState({VirtualPhoneNum:VirtualPhoneNum,loading:false})
                this.setState({ loading: false })
            }

            if (phone.PHONETYPE === "座机") {
                // this.setState({VirtualPhoneNum:VirtualPhoneNum})
            }

            this.setState({ PHONEDate: phone, SECRET: SECRET, PHONETYPE: PHONETYPE, RATE: RATE, SOURCE: SOURCE })
        }
        else if (result.status === 10) {
            Cache.logout(this.props);
        }
    }

    comfirmVirtualNum = () => {
        let date = moment().add(0.5, 'hours').format('HH:mm');
        const { messageOptions, cell } = this.state;
        messageOptions["isMessage"] = false;
        messageOptions['title'] = '参考话术';
        messageOptions['message'] = <div>
            {
                cell ?
                    <p>此号码为虚拟号，30分钟内有效，请使用注册手机号码{cell}呼叫，{date}失效</p>
                    :
                    <p>此号码为虚拟号，30分钟内有效，请注册手机号码呼叫，{date}失效</p>
            }

            <p>1、喂，您好，请问是XXX公司嘛？（潜在客户确认）</p>
            <p>2、我这边是某某银行XX分行的张三，距离咱们公司不远！（表明身份拉近距离）</p>
            <p>3、按照国家扶持中小微企业的政策，目前我们XX银行为咱们企业提供了利率低至（2.8--4.5%）的贴息企业贷款，想问问咱们企业的基本情况是否吻合政策要求，请问咱们成立时间多久了，哦刚成立呀，那咱们企业在银行完成开户了嘛，我们行目前正开展企业开户有礼的活动，对于新开户企业提供企业大礼包，包括转账汇款手续费减半，低息贷款、企业理财等…………（沟通内容提供对企业有吸引有价值的各类服务，不必仅局限于新企业开户，很多企业主还有关联企业也可借此展开名下其它企业的贷款推介）</p>
        </div>
        messageOptions['confirmFunction'] = this.onComfirmVirtualNum;
        this.state['messageOptions'] = messageOptions;
        this.messageRef.open();
    }

    onComfirmVirtualNum = () => {
        setTimeout(() => {
            this.VirtualPhoneClick();
        }, 100);
    }

    /**
    * 虚拟手机号
    */
    VirtualPhoneClick() {

        let { basePath, PHONEDate, messageOptions } = this.state;
        if (PHONEDate.PHONETIMES === 0 && PHONEDate.PHONEID !== undefined) {
            let params = {
                PHONEID: PHONEDate.PHONEID
            };

            WidgetAjax.ajax({ url: basePath + '/phone/bind_virtualphone', params: params, callback: this.onVirtualPhoneClick });
        }
        else {
            messageOptions["isMessage"] = false;

            messageOptions["message"] = "本日无可拨打次数请明日8:00再试!";
            messageOptions['confirmFunction'] = () => { }
            this.messageRef.open();
        }

    }

    onVirtualPhoneClick(result, params) {
        console.log(result);

        let { messageOptions } = this.state;

        if (result.status === 0) {
            let data = result.result;

            let VirtualPhoneNum = data.PHONE;

            this.setState({ reciprocal: true, VirtualPhoneNum: VirtualPhoneNum, loadingPhone: false })
        }
        else if (result.status === 10) {
            Cache.logout(this.props);
        }
        else {

            this.setState({ reciprocal: false })

            messageOptions["isMessage"] = true;

            messageOptions["message"] = "您的账号不是手机号!";

            this.messageRef.open();
        }
    }

    render() {
        const { item, entity, entityType, features, risks, catalogs, clues, tags, tels, amap, tel, mail, messageOptions, loading, headersHeight, tabHeight, isBackTop, scrollTop, curIndex, reciprocal, VirtualPhoneNum, PHONEDate, SECRET, PHONETYPE, RATE, SOURCE, isNewFirm } = this.state;
        const { attributes } = this.props;
        if (RATE < 60) {
            this.state['PHONEDate'] = undefined
        }
        return (
            <>{loading ?
                <div className="img-loading"><img src={require('./../img/frame/loading.gif')} className="loading-detail" alt="es-lint want to get" /></div>
                :
                <div className="page overflow" id="entityDetailPage" onScroll={this.Scroll} ref={this.getHead}>

                    <div className="left-content padding-right-8 left">

                        <div style={headersHeight > 0 ? { height: headersHeight } : { height: "auto" }}>
                            <div className="overview white paddingauto margin-buttom-8" id="entityDetailHeaders" style={headersHeight > 0 ? { width: "938px", position: "fixed", background: "#ffffff", zIndex: "101" } : { position: "none" }} ref={el => this.headers = el}>
                                <div className="entity-logo">
                                    {
                                        () => {
                                            if (entity.LOGO !== undefined) {
                                                const image = "data:image/png;base64," + entity.LOGO;

                                                return <img src={image}></img>
                                            }
                                            else {
                                                return <></>
                                            }
                                        }
                                    }
                                </div>
                                <div className="entity-info">
                                    <div className="detail-title" style={{ width: "800px" }}>
                                        <span className="enity-title">{item.ENTNAME || item.entName}</span>
                                        <label className="enity-regstate-label">{entity.REGSTATE}</label>
                                    </div>
                                    <div className="entity-tag">
                                        <div className="label">
                                            <Features features={tags} className='label-body tags' changeMore={this.Scroll}></Features>
                                            <Features features={features} className='label-body feature'></Features>
                                            <Features features={risks} className='label-body risk'></Features>
                                            <Features features={catalogs} className='label-body risk'></Features>
                                            <Features features={clues} className='label-body risk'></Features>
                                        </div>
                                    </div>
                                    <div className="entity-basic-info">
                                        <div className="DOM">
                                            <span className="">经营地址:</span>
                                            <span className="">{entity.DOM}</span>
                                        </div>
                                        {/* <div className="REGSTATE">
                                                <span className="">经营状态:</span>
                                                <span className="">{entity.REGSTATE}</span>
                                            </div> */}
                                        <div className="ENTTYPE">
                                            <span className="">行业类型:</span>
                                            <span className="">{entity.INDUSTRYPHY}</span>
                                        </div>
                                        <div className="ESTDATE">
                                            <span className="">成立时间:</span>
                                            <span className="">{entity.ESTDATE}</span>
                                        </div>
                                        {/* <div className="flow">
                                                <span className="">跟进情况:</span>
                                                <span className="">{entity.ESTDATE}</span>
                                            </div> */}
                                    </div>
                                </div>

                                <div className="entity-oprations">
                                    <div className="tips-button icon-button click addMonitor" onClick={this.addMonitor} style={entity.MONITOR !== true ? { display: 'block', float: 'right' } : { display: 'none' }}>
                                        添加监控
                                    </div>
                                    <div className="tips-button icon-button click removeMonitor" onClick={this.removeMonitor} style={entity.MONITOR === true ? { display: 'block', float: 'right' } : { display: 'none' }}>
                                        取消监控
                                    </div>

                                    <div className="tips-button icon-button click addCRM" onClick={this.addCRM} style={entity.CRM !== true ? { display: 'block', float: 'right' } : { display: 'none' }}>
                                        添加CRM
                                    </div>
                                    <div className="tips-button icon-button click removeCRM" onClick={this.removeCRM} style={entity.CRM === true ? { display: 'block', float: 'right' } : { display: 'none' }}>
                                        取消CRM
                                    </div>

                                    {/* <div className="tips-button icon-button click addFavor" onClick={this.addFavor}  style={ entity.FAVOR!==true ? {display:'block', float:'right'} : {display:'none' }}>
                                            添加收藏
                                        </div>
                                        <div className="tips-button icon-button click removeFavor" onClick={this.removeFavor}  style={ entity.FAVOR===true ? {display:'block', float:'right'} : {display:'none' }}>
                                            取消收藏
                                        </div> */}
                                </div>
                            </div>
                        </div>



                        <div className="content white">

                            {/* <>{this.props.font?
                                        <div className="tab tabStyleClass" style={headersHeight>0?{position:"fixed",width:"938px",zIndex:"101",background:"#ffffff",top:headersHeight,borderTop:"8px solid rgba(226,226,226)",height:"64px"}:{position:"none"}}>
                                          <label className="label_common click label_active" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 1)}><span>{this.props.font}</span></label>
                                         { !entity.MONITOR 
                                            ? <> 
                                                <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 2)}><span>行业知识点</span></label>
                                                <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 3)}><span>企业全景</span></label>
                                           </> : <>{this.props.flag===undefined?<>
                                                    <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 3)}><span>企业全景</span></label>
                                                    <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 4)}><span>监控预警</span></label>
                                                    </>:<>
                                                    <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 4)}><span>企业全景</span></label>
                                                    <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 3)}><span>监控预警</span></label>
                                                </>}
                                            </>}
                                            <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 5)}><span>跟进记录</span></label>
                                            <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 6)}><span>经营评价</span></label>
                                            <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 7)}><span>风险评价</span></label>
                                            <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 8)}><span>相似企业</span></label>
                                        </div>
                                        : */}
                            <div className="tab tabStyleClass" style={headersHeight > 0 ? { position: "fixed", width: "938px", zIndex: "101", background: "#ffffff", top: headersHeight, borderTop: "8px solid rgba(226,226,226)", height: "64px" } : { position: "none" }}>
                                {/* { !entity.MONITOR 
                                            ? <> 
                                                    <label className="label_common click label_active" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 2)}><span>基础画像</span></label>
                                                    <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 8)}><span>行业知识点</span></label>
                                           </> : <>{this.props.flag===undefined?<>
                                                    <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 8)}><span>行业知识点</span></label>
                                                    <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 2)}><span>基础画像</span></label>
                                                    <label className="label_common click label_active" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 1)}><span>监控预警</span></label>
                                                    </>:<>
                                                    <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 8)}><span>行业知识点</span></label>
                                                    <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 2)}><span>基础画像</span></label>
                                                    <label className="label_common click label_active" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 1)}><span>监控预警</span></label>
                                                </>}
                                            </>} */}
                                {/* { isNewFirm && <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 7)}><span>新企推荐度</span></label> } */}
                                <label className="label_common click label_active" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 2)}><span>基础画像</span></label>
                                {/* <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 3)}><span>跟进记录</span></label> */}
                                <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 4)}><span>财务画像</span></label>
                                <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 3)}><span>交易画像</span></label>
                                <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 5)}><span>行业画像</span></label>
                                {/* <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 6)}><span>相似企业</span></label> */}
                                <label className="label_common click " style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 8)}><span>获客方案</span></label>
                                {/* <label className="label_common click" style={{ fontSize: '14px' }} onClick={this.labelChange.bind(this, "entity", 7)}><span>新企推荐度</span></label>
                                             */}
                            </div>
                            {/* }</> */}



                            <div style={headersHeight > 0 ? { height: "56px", display: "block" } : { display: "none" }}></div>


                            {/* {this.props.font?
                                    <div>
                                        <div className="panorama" style={entityType === 1 ? { display: 'flex'} : { display: 'none' }}>
                                                < EntityVertical ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} font={this.props.font} />
                                        </div>  
                                        {!entity.MONITOR ? 
                                         <> 
                                            {entityType === 2 &&
                                                <div className="panorama" >
                                                    <EntityKnowledge ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                </div>  
                                            }
                                            <>{entityType === 3 &&
                                                    <div className="panorama" >
                                                        <EntityPanorama ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                } </> 
                                            
                                        </>  : <> 
                                            {this.props.flag===undefined?<>

                                                {entityType === 2 &&
                                                    <div className="panorama" >
                                                        <EntityKnowledge ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }
                                                <>{entityType === 3 &&
                                                    <div className="panorama" >
                                                        <EntityPanorama ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }</>
                                                <div style={entityType === 4 ? { display: 'block', minHeight: 'calc(100vh - 298px)' } : { display: 'none' }}>
                                                    <EntityDevelopment ENTNAME={item.ENTNAME} parentProps={this.props} />
                                                </div>
                                            </>:<>

                                                {entityType === 2 &&
                                                    <div className="panorama" >
                                                        <EntityKnowledge ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }
                                                <>{entityType === 4 &&
                                                    <div className="panorama" >
                                                        <EntityPanorama ENTNAME={item.ENTNAME} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }</>
                                                <div style={entityType === 3 ? { display: 'block', minHeight: 'calc(100vh - 298px)' } : { display: 'none' }}>
                                                    <EntityDevelopment ENTNAME={item.ENTNAME} parentProps={this.props}/>
                                                </div>
                                                </>}
                                        </>}
                                        <div className="panorama" style={entityType === 54 ? { display: 'flex'} : { display: 'none' }}>
                                            <Record />
                                        </div>

                                        {entityType === 6 &&
                                            <div className="panorama" >
                                                <Valuation ENTNAME={item.ENTNAME} scrollHeight={this.head.scrollHeight}  clientHeight={this.head.clientHeight} scrollTop={this.state.scrollTop} setScrollTop={top => this.setScrollTop(top)} headersHeight={headersHeight} />
                                            </div>  
                                        }
                                        {entityType === 7 &&
                                            <div className="panorama" >
                                                <Risk ENTNAME={item.ENTNAME} scrollHeight={this.head.scrollHeight}  clientHeight={this.head.clientHeight} scrollTop={this.state.scrollTop} setScrollTop={top => this.setScrollTop(top)} headersHeight={headersHeight} />
                                            </div>  
                                        }
                                        <div className="panorama" style={entityType === 8 ? { display: 'flex'} : { display: 'none' }}>
                                            <Similar />
                                        </div>
                                    </div>
                                : */}
                            <div>
                                {/* <>{!entity.MONITOR 
                                        ? <>
                                            {entityType === 8 &&
                                                <div className="panorama" >
                                                    <EntityKnowledge ENTNAME={item.ENTNAME||item.entName} INDUSTRY={entity.INDUSTRYCO} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                </div>  
                                            }
                                            <>{entityType === 1 &&
                                                <div className="panorama" >
                                                    <EntityPanorama ENTNAME={item.ENTNAME||item.entName} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                </div>  
                                            }</>
                                            
                                        </> : <> {this.props.flag===undefined?<>
                                                {entityType === 8 &&
                                                    <div className="panorama" >
                                                        <EntityKnowledge ENTNAME={item.ENTNAME||item.entName} INDUSTRY={entity.INDUSTRYCO} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }
                                                <>{entityType === 2 &&
                                                    <div className="panorama" >
                                                        <EntityPanorama ENTNAME={item.ENTNAME||item.entName} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }</>
                                                <div style={entityType === 1 ? { display: 'block', minHeight: 'calc(100vh - 298px)' } : { display: 'none' }}>
                                                    <EntityDevelopment ENTNAME={item.ENTNAME||item.entName} parentProps={this.props} />
                                                </div>
                                            </>:<>
                                                {entityType === 8 &&
                                                    <div className="panorama" >
                                                        <EntityKnowledge ENTNAME={item.ENTNAME||item.entName} INDUSTRY={entity.INDUSTRYCO} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }
                                                {entityType === 2 &&
                                                    <div className="panorama" >
                                                        <EntityPanorama ENTNAME={item.ENTNAME||item.entName} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                                    </div>  
                                                }
                                                <div style={entityType === 1 ? { display: 'block', minHeight: 'calc(100vh - 298px)' } : { display: 'none' }}>
                                                    <EntityDevelopment ENTNAME={item.ENTNAME||item.entName} parentProps={this.props}/>
                                                </div>
                                                </>}
                                        </>}</> */}
                                {entityType === 2 &&
                                    <div className="panorama" >
                                        {/* <Registration ENTNAME={item.ENTNAME || item.entName} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop}  setScrollTop={top => this.setScrollTop(top)} headersHeight={headersHeight} /> */}
                                        <EntityPanorama ENTNAME={item.ENTNAME || item.entName} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} setScrollTop={top => this.setScrollTop(top)}/>
                                    </div>
                                }
                                <div className="panorama" style={entityType === 3 ? { display: 'flex' } : { display: 'none' }}>
                                    <Transaction />
                                    {/* <Record /> */}
                                </div>

                                {entityType === 4 &&
                                    <div className="panorama" >
                                        <Valuation ENTNAME={item.ENTNAME || item.entName} scrollHeight={this.head.scrollHeight} clientHeight={this.head.clientHeight} scrollTop={this.state.scrollTop || 0} setScrollTop={top => this.setScrollTop(top)} headersHeight={headersHeight} />
                                    </div>
                                }
                                {entityType === 5 &&
                                    <div className="panorama" >
                                        <Risk ENTNAME={item.ENTNAME || item.entName} scrollHeight={this.head.scrollHeight} clientHeight={this.head.clientHeight} scrollTop={this.state.scrollTop} setScrollTop={top => this.setScrollTop(top)} headersHeight={headersHeight} />
                                    </div>
                                }

                                {entityType === 8 &&
                                    <div className="panorama" >
                                        <EntityKnowledge ENTNAME={item.ENTNAME || item.entName} INDUSTRY={entity.INDUSTRYCO} parentProps={this.props} headersHeight={headersHeight} scrollTop={scrollTop} />
                                    </div>
                                }

                                <div className="panorama" style={entityType === 6 ? { display: 'flex' } : { display: 'none' }}>
                                    <Similar />
                                </div>

                                <div className="panorama" style={entityType === 7 ? { display: 'flex' } : { display: 'none' }}>
                                    <NewEnt></NewEnt>
                                </div>

                                {/* <>{entityType === 7 &&
                                                <div className="panorama" >
                                                    <EntityRecommend/>
                                                </div>  
                                        }</> */}

                            </div>
                            {/* } */}
                        </div>
                        {/* 回到顶部按钮 */}
                        <div className={isBackTop ? 'backTop' : "display-none"} onClick={this.setTop} style={{ position: "fixed", right: "300px", bottom: "110px", zIndex: "99", cursor: "pointer" }}>
                            <img className="backTopImg" src={BackToTop} />
                        </div>

                    </div>
                    <div className="right-content right white" style={headersHeight > 0 ? { height: "100%", width: "237px", right: "18px", position: "fixed", background: "#ffffff", zIndex: "100", overflowY: "scroll" } : { position: "none", height: "100%", overflowY: "scroll" }}>

                        <div className="phone-info">
                            <img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            <span>隐私联系方式</span>
                        </div>
                        {PHONEDate !== undefined ?
                            <>{loading ?
                                <div className="img-loading"><img src={require('./../img/frame/loading.gif')} className="loading-detail" alt="es-lint want to get" /></div>
                                :
                                <div className='VirtualPhone'>
                                    <p><span className='left'>姓名:</span><span>xxx</span></p>
                                    <p><span className='left'>职位:</span><span>xxx</span></p>
                                    <p><span className='left'>来源:</span><span>{SOURCE}</span></p>
                                    <p><span className='left'>类型:</span><span>{PHONETYPE}</span></p>
                                    <p><span className='left'>正确率:</span><span>{RATE}%</span></p>
                                    <p style={{ display: "flex", flexDirection: 'column' }}>
                                        <label style={{ width: "276px", fontSize: "12px" }}>备注:</label>
                                        <span style={{ fontSize: "12px" }}>
                                            1、由于营销对象是新注册的企业，为了降低对潜在客户的打扰，不允许直接推销新企业开户服务，建议以国家扶持低息贷款切入沟通，先创造良好沟通氛围；
                                        </span>
                                        <span style={{ fontSize: "12px" }}>
                                            2、为了提升潜在客户的信任度，要求用语礼貌，并第一时间表明身份，如某某银行XX分行的张三；
                                        </span>
                                    </p>
                                    {/* { VirtualPhoneNum ?
                                            <button className='VirtualPhoneClick' 
                                                disabled 
                                                style={SECRET===0? { background:"rgba(4, 242, 28, 1)"} : {background:"rgba(242, 110, 4, 1"} } 
                                                onClick={this.VirtualPhoneClick}
                                            >
                                                <div className='divImg' style={SECRET===0?{background:"rgba(3, 195, 22, 1)"}:{background:"rgba(195, 88, 3, 1)"}}>
                                                    <img src={require("../img/riskCompass/virtualPhone.svg")} alt="es-lint want to get"></img>
                                                </div>
                                                <div className='Ps'>
                                                    <p className='tell'>{ VirtualPhoneNum!==undefined ? VirtualPhoneNum : "电话联系TA"}</p>
                                                    <p>本日可拨打次数2次</p>
                                                </div>
                                            </button>
                                        : */}
                                    <button
                                        className='VirtualPhoneClick' 
                                        // disabled={!isNewFirm}
                                        // className={`VirtualPhoneClick ${!isNewFirm ? 'virtualPhoneMask' : ''}`}
                                        style={SECRET === 0 ? { background: "rgba(4, 242, 28, 1)" } : { background: "rgba(242, 110, 4, 1" }}
                                        onClick={this.comfirmVirtualNum}
                                    >
                                        <div className='divImg' style={SECRET === 0 ? { background: "rgba(3, 195, 22, 1)" } : { background: "rgba(195, 88, 3, 1)" }}>
                                            <img src={require("../img/riskCompass/virtualPhone.svg")} alt="es-lint want to get"></img>
                                        </div>
                                        <div className='Ps'>
                                            <p className='tell'>{VirtualPhoneNum !== undefined ? VirtualPhoneNum : "电话联系TA"}</p>
                                            <p>{reciprocal ? "此号码30分钟有效" : "本日可拨打次数2次"}</p>
                                        </div>
                                    </button>
                                    {/* } */}

                                </div>
                            }</>
                            :
                            <div className='noAvailable'>暂无数据！</div>
                        }


                        <div className="phone-info">
                            <img src={require("../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            <span>联系方式</span>
                        </div>
                        <div className='phone-list' style={{ height: "100%" }}>
                            {
                                tels.map((item, index) => {
                                    return (
                                        <>{item.name ? <div className='item'>
                                            <p>
                                                <img style={{ width: "12px" }} src={telePhone} />
                                                <span style={{ paddingLeft: "8px" }}>
                                                    {item.tel}
                                                </span>
                                            </p>
                                            <p style={{ paddingLeft: "20px", paddingTop: "5px", fontSize: "14px" }}>姓名: {item.name}</p>
                                            <p style={{ paddingLeft: "20px", fontSize: "14px" }}>来源: {item.src}</p>
                                        </div> : <div className='item'>
                                            <p>
                                                <img style={{ width: "12px" }} src={telePhone} />
                                                <span style={{ paddingLeft: "8px" }}>
                                                    {item.tel}
                                                </span>
                                            </p>
                                            <p style={{ paddingLeft: "20px", fontSize: "14px" }}>来源: {item.src}</p>
                                        </div>}</>

                                    )
                                })
                            }
                        </div>
                    </div>

                    {
                        this.props.WidgetVertical
                            ?
                            <div style={headersHeight > 0 ? { display: "block", width: "254px", height: "31px", float: "right", marginLeft: "10px", overflowY: "none" } : { display: "none" }}></div>
                            :
                            <></>
                    }

                    <WidgetMessage options={messageOptions} onRef={this.setMessageRef} />

                    <WidgetModal options={messageOptions} onRef={this.modelRef}>
                        <div>

                        </div>

                    </WidgetModal>

                </div>
            }</>
        )
    }
}




export default EntityDetail